import React from "react"
import "./style.scss"

const Description = ({ children, type = '' }) => {
  return <div className={`description ${type}`}>{children}</div>
}

export default Description
